



























































































































import { Component, Emit, Vue, Watch } from 'vue-property-decorator'
import { env } from '@ivy/fts/envInfo/envInfo'
import showDiv from '@ivy/fts/showDiv'
import BulletinBoard from '../comps/bulletin-board.vue'
import MyTeam from '../comps/my-team.vue'
import TeamStrategy from '../comps/team-strategy.vue'
import RewardIntroduce from '../comps/reward-introduce.vue'
import ShipAddress from '../comps/ship-address.vue'
import InviteMore from '../comps/invite-more.vue'
import RulePanel from '../comps/rule-panel.vue'
import StatusDialog from '../comps/status-dialog.vue'
import ShareModel from '../comps/share-model.vue'
import ShareSuccessModel from '../comps/share-success.vue'
import HeadVideo from '../comps/head-video.vue'
import GoodsInfo from '../comps/goods-info.vue'
import {
  requireGet,
  requirePost,
  addStatistics,
  ChangeURLArg,
  startStatisticsTime,
  endtStatisticsTime,
} from '../api'
import config from '../../../config'

@Component({
  components: {
    BulletinBoard,
    MyTeam,
    TeamStrategy,
    RewardIntroduce,
    ShipAddress,
    InviteMore,
    ShareModel,
    HeadVideo,
    RulePanel,
    GoodsInfo,
  },
})
export default class Detail extends Vue {
  ios10Shadow: boolean = false
  head_img: any
  noticeList: any[] = []
  id: any = ''
  invitedId: any = ''
  myTeamId: any = ''
  child_activity_Info: any = {
    config: {},
  }
  team_attend_Info: any[] = []
  showShipAddress: boolean = false
  address_info: any = {}
  receiverId: any
  attend_receiverId: any
  defaultReceiverId: any
  showShare: boolean = false
  need_num: string = ''
  //阶梯数
  stage_num: number = 1
  activityId: any
  rules: any
  rewardInfo: any
  showDetail: boolean = false
  isConfirmed: boolean = false
  showBottom: boolean = false
  //是否是新用户
  isNewer: boolean = true
  join_auth: boolean = true
  //是否有作为队员的领奖权限
  join_reward_auth: boolean = false
  //是否有作为队长的领奖权限
  publish_reward_auth: boolean = false
  //加入组队类型为no_gift_authority_app时，是否已登陆过目标app
  authority_app: any
  isPhysical: boolean = true
  fulled: boolean = false
  share_img_url: any
  team_name: any
  team_status: any = ''
  auth: boolean = false
  shareAppName: string = ''
  appName: string = ''
  success_desc: string = ''
  activity_code: any = ''
  addressId: any = ''
  showAddress: boolean = true
  isSuccess: boolean = false
  showHeadVideo: boolean = false
  videoUrl: string = ''
  videoPoster: string = ''
  chooseApp: string = ''
  //二维码图片
  qr_code_url: string = ''
  //加入组队用户类型
  //no_register常爸全平台未注册用户
  //no_gift_authority未有该奖品权限的用户
  //no_gift_authority_app未有该奖品权限且未在某App活跃过的用户
  user_type: string = 'no_gift_authority'
  isPopService: boolean = false
  mem_id: any = ''
  displayPercent: number = 0
  userType: any = 0 // 埋点用户类型 1 发起用户, 2 加入用户, 0 未登录用户
  goodsState: boolean = true
  remain: any = +new Date()
  //奖品数据
  configInfo: any
  isShowReward = false

  @Watch('displayPercent')
  async upDisplayPercent(val) {
    // 埋点-组队活动详情页访问百分比
    try {
      await addStatistics({
        activity_id: this.activityId,
        event_type: 'Display_Percent_DetailsPage_xszd',
        p1: this.id,
        p2: env.type === 'ivydad' ? this.appName : 'h5',
        p3: this.userType,
        p4: val,
        p5: this.remain,
      })
    } catch {}
  }

  async created() {
    document.title = '组队免费领'
    await env.init()
    if (env.type === 'web') return this.$Toast('请在App或微信中打开')
    if (env.type === 'ivydad') {
      let info = await env.getInfo()
      this.appName = info ? info.publicParams.app_name : ''
    }
    this.activityId = this.$route.query.activityId
    this.id = this.$route.query.id
    if (!this.activityId || !this.id) {
      return this.$Toast('活动不存在～')
    }
    this.invitedId = this.$route.query.team_id || ''
    //初始化活动信息
    await this.initActivityInfo()
    await this.addIndexStatistics()
    env.type === 'wx' && (await this.setShare())
  }
  async destroyed() {
    endtStatisticsTime('Display_Duration_DetailsPage_xszd')
  }
  async setShare() {
    let shareData = {
      title: `我在【常青藤爸爸】发现了高效好课`,
      content: `快来跟我一起组队免费领！`,
      pic_url: this.head_img,
      url: window.location.href,
    }
    await env.share(shareData)
  }
  // 埋点
  async addIndexStatistics() {
    if (this.invitedId) {
      try {
        // 埋点-扫描海报二维码
        await addStatistics({
          activity_id: this.activityId,
          event_type: 'ScanPosters_xszd',
          p1: this.id,
          p2: env.type === 'ivydad' ? this.appName : 'h5',
        })
      } catch {}
    }
    try {
      // 埋点-组队活动详情页访问
      await addStatistics({
        activity_id: this.activityId,
        event_type: 'Display_DetailsPage_xszd',
        p1: this.id,
        p2: env.type === 'ivydad' ? this.appName : 'h5',
        p3: this.userType,
      })
      // 埋点-组队活动详情页访问时长
      // await startStatisticsTime('Display_Duration_DetailsPage_xszd', {
      //   activity_id: this.activityId,
      //   event_type: 'Display_Duration_DetailsPage_xszd',
      //   p2: env.type === 'ivydad' ? this.appName : 'h5',
      //   p3: this.userType,
      //   p1: this.id,
      // })
    } catch {}
  }

  scrollHandeler() {
    this.getPercent()
    const myTeamDom: any = document.getElementById('myTeam')
    const myTeamRect = myTeamDom && myTeamDom.getBoundingClientRect()
    if (myTeamRect && myTeamRect.bottom <= 40) {
      this.showBottom = true
    } else {
      this.showBottom = false
    }
  }
  // 添加滚动事件
  addScrollEvent() {
    const container: any = this.$refs.indexContainer
    container &&
      container.addEventListener(
        'scroll',
        this.debounce(this.scrollHandeler, 100)
      )
  }
  // 防抖
  debounce(fn, wait) {
    let timeout = null
    return () => {
      if (timeout !== null) clearTimeout(timeout)
      timeout = setTimeout(fn, wait)
    }
  }
  async getNoticeList() {
    const { data } = await requireGet(
      `/api/activity/appActivity/teamActivity/getBroadcast?team_activity_id=${
        this.id
      }`
    )
    this.noticeList = data || []
  }

  // 获取活动信息
  async initActivityInfo() {
    this.isShowReward = false
    const { data: activityInfo } = await requireGet(
      `/api/activity/appActivity/teamActivity/getActivityInfo?team_activity_id=${
        this.id
      }&activity_id=${this.activityId}`
    )
    this.activity_code = activityInfo.status_code || ''
    this.child_activity_Info = activityInfo.activity_info || activityInfo
    //zmtest
    // this.child_activity_Info.config.stage_info = {
    //   1: { stage_need_num: 2, stage_limit: 10 },
    //   2: { stage_need_num: 3, stage_limit: 10 },
    // }
    // this.child_activity_Info.config.stage_num = 2
    this.configInfo = this.child_activity_Info.config
    this.stage_num = this.child_activity_Info.config.stage_num
    this.showAddress =
      +new Date(this.child_activity_Info.end_time.replace(/-/g, '/')) +
        1000 * 60 * 60 * 24 * 7 >
      +new Date()
    //根据当前活动状态显示弹框类型
    if (this.activity_code === 'ACTIVITY_NOT_EXIST') {
      //活动不存在
      this.$Toast(activityInfo.message)
      return
    } else if (
      this.activity_code === 'ACTIVITY_HAS_END' ||
      this.activity_code === 'ACTIVITY_LIMIT'
    ) {
      //活动已经结束 活动限量已达上线
      this.showStatus({ status: 7 })
    } else if (this.activity_code === 'ACTIVITY_NOT_BEGIN') {
      //活动没开始
      this.showStatus({
        status: 1,
        begin_time: this.child_activity_Info.begin_time,
      })
      return
    }
    this.isNewer = this.child_activity_Info.is_new_user

    //是否可加入组队
    this.join_auth = this.child_activity_Info.join_auth
    this.authority_app = this.child_activity_Info.authority_app
    this.qr_code_url = this.child_activity_Info.qr_code_url
    this.goodsState = this.child_activity_Info.goods_state
    if (!this.goodsState) this.$Toast('奖品异常，请联系客服')
    //头部显示
    let headList = this.child_activity_Info.config.head_list || []
    let headInfo =
      headList.filter(
        el =>
          el.ispublish === 'yes' &&
          el.isshow === 'yes' &&
          +new Date(el.begin_time.replace(/-/g, '/')) < +new Date() &&
          +new Date(el.end_time.replace(/-/g, '/')) > +new Date()
      )[0] || {}
    //true说明当前奖励不可领
    this.auth = this.child_activity_Info.auth
    this.join_reward_auth = this.child_activity_Info.join_reward_auth
    this.publish_reward_auth = this.child_activity_Info.publish_reward_auth
    this.head_img = headInfo.head_img_url
    this.videoUrl = headInfo.head_video_url
    this.videoPoster = headInfo.head_video_img_url
    this.showHeadVideo = !!this.videoUrl
    //组队人数显示

    if (this.child_activity_Info.config.stage_info) {
      for (let key in this.child_activity_Info.config.stage_info) {
        let item = this.child_activity_Info.config.stage_info[key]
        this.need_num += item.stage_need_num
        if (Number(key) != this.child_activity_Info.config.stage_num) {
          this.need_num += '、'
        }
      }
    }
    //活动规则
    this.rules = this.child_activity_Info.config.rule
    //奖品介绍
    this.rewardInfo = this.child_activity_Info.config.reward_details || []
    this.team_name = this.child_activity_Info.config.team_name
    this.shareAppName = this.child_activity_Info.config.targe_app
    this.success_desc = this.child_activity_Info.config.route_word
    this.chooseApp = this.child_activity_Info.config.choose_app
    this.user_type = this.child_activity_Info.config.user_type
    await this.initTeamDetail()
    await this.getNoticeList()
    this.showDetail = true
    await this.$nextTick(() => {
      this.getPercent()
      this.addScrollEvent()
    })
  }

  // 获取参与信息
  async initTeamDetail() {
    this.receiverId = +this.$route.query.receiver_id || ''
    let team_id = this.invitedId || ''
    const { data: teamInfo } = await requireGet(
      `/api/activity/appActivity/teamActivity/getMyTeamInfo?team_activity_id=${
        this.id
      }&team_id=${team_id}`
    )
    this.isPhysical = teamInfo.is_physical
    //筛选出当前组队的人
    this.team_attend_Info =
      (teamInfo.teams_attend &&
        teamInfo.teams_attend.attend_info &&
        teamInfo.teams_attend.attend_info.filter(
          item => +item.team_activity_id === +this.id
        )) ||
      []
    let memId
    if (await env.getIsLogin()) {
      let info = await env.getInfo()
      memId = env.type === 'wx' ? info.logined.user.id : info.userInfo.memId
    } else {
      memId = ''
    }
    this.mem_id = memId
    if (memId && this.team_attend_Info) {
      let myTeamInfo = this.team_attend_Info.find(
        item => +item.mem_id === +memId
      )
      if (myTeamInfo) {
        //是否是发起者
        this.userType = myTeamInfo.is_organizer ? 1 : 2
        //是否确认地址
        this.isConfirmed = !!myTeamInfo.is_confirm
        //收货地址id
        this.attend_receiverId = myTeamInfo.receiver_id
        //是否加入组队标识  组队的id
        this.myTeamId = myTeamInfo.team_id
        this.addressId = myTeamInfo.id
        this.isPopService = (await requireGet(
          `/api/activity/appActivity/teamActivity/judegePopWindow?team_id=${
            this.myTeamId
          }&team_activity_id=${this.id}`
        )).data
      }
    }
    this.team_status = teamInfo.status_code
    if (this.isPopService) {
      return this.toService()
    }
    if (teamInfo.status_code === 'TEAM_IS_WAITING') {
      //组队进行中
      //没有登陆过指定app并且不是队长
      let nologinList = this.team_attend_Info.filter(
        team => !team.is_login && !team.is_organizer
      )
      if (
        env.type === 'wx' &&
        nologinList &&
        nologinList.findIndex(el => el.mem_id === +memId) !== -1
      ) {
        this.showStatus({ status: 2, shareAppName: this.shareAppName })
      } else if (
        this.shareAppName !== this.appName &&
        nologinList &&
        nologinList.findIndex(el => el.mem_id === +memId) !== -1
      ) {
        this.showStatus({ status: 9, shareAppName: this.shareAppName })
      } else if (
        this.join_reward_auth &&
        this.invitedId &&
        this.userType !== 1
      ) {
        //如果不是队长 并且已有该奖品奖励 弹
        this.showStatus({ status: 11 })
      } else if (
        this.invitedId &&
        this.user_type === 'no_gift_authority_app' &&
        this.authority_app &&
        !this.join_auth
      ) {
        //如果加入类型为 未领奖并且未登录过指定app 此时登陆过该app 弹框提示
        this.showStatus({
          status: 12,
          shareAppName: this.chooseApp,
          child_id: this.id,
          auth: this.publish_reward_auth,
        })
      } else if (
        //如果不是队长并且当前加入类型为新用户 用户不是新用户时提示老用户弹窗
        this.userType !== 1 &&
        this.user_type === 'no_register' &&
        !this.isNewer
      ) {
        this.showStatus({
          status: 5,
          child_id: this.id,
          auth: this.join_reward_auth,
        })
      }
    } else {
      if (teamInfo.status_code === 'TEAM_HAS_FULL') {
        //组队名额已满
        if (
          this.activity_code !== 'ACTIVITY_HAS_END' &&
          this.activity_code !== 'ACTIVITY_LIMIT'
        ) {
          this.fulled = true
          this.showStatus({
            status: 6,
            child_id: this.id,
            auth: this.publish_reward_auth,
          })
        }
      } else if (teamInfo.status_code === 'TEAM_HAS_SUCCESS') {
        //已组队
        this.fulled = true

        //组队成功了 但我不在这个队伍中 但有邀请链接
        if (!this.myTeamId && this.invitedId) {
          this.showStatus({
            status: 6,
            child_id: this.id,
            auth: this.publish_reward_auth,
          })
          return
        }
        if (this.myTeamId) {
          let myTeamInfo = this.team_attend_Info.find(
            item => +item.mem_id === +memId
          )
          //如果我在这个队伍中 但我不是队长并且没有登陆过指定app
          if (
            myTeamInfo &&
            myTeamInfo.status === 'no_login' &&
            !myTeamInfo.is_organizer
          ) {
            this.showStatus({
              status: 8,
              child_id: this.id,
              auth: this.publish_reward_auth,
            })
            return
          }
          if (
            this.activity_code !== 'ACTIVITY_HAS_END' &&
            this.activity_code !== 'ACTIVITY_LIMIT'
          ) {
            this.isSuccess = true
            this.isPhysical
              ? this.goToShipAddress()
              : this.showStatus({ status: 4, success_desc: this.success_desc })
          }
        }
      } else if (
        teamInfo.status_code === 'TEAM_HAS_FAIL' &&
        +new Date() <
          +new Date(this.child_activity_Info.end_time.replace(/-/g, '/'))
      ) {
        if (
          this.activity_code !== 'ACTIVITY_HAS_END' &&
          this.activity_code !== 'ACTIVITY_LIMIT'
        ) {
          this.showStatus({
            status: 8,
            child_id: this.id,
            auth: this.publish_reward_auth,
          })
        }
      }
    }
    // 登录才更新地址
    if ((await env.getIsLogin()) && this.addressId) {
      await this.updateAddressInfo()
    }
  }

  // 更新地址
  async updateAddressInfo() {
    this.receiverId = +this.$route.query.receiver_id || ''
    if (this.receiverId && +this.receiverId !== +this.attend_receiverId) {
      let { data: addressInfo } = await requirePost(
        '/api/mobile/course/yaya/getUserReceiver',
        {
          id: this.receiverId,
        }
      )
      if (!addressInfo.length) return (this.receiverId = '')
      await requirePost(
        '/api/activity/appActivity/teamActivity/updateReciverId',
        {
          team_id: this.myTeamId,
          receiver_id: this.receiverId,
          team_activity_id: this.id,
        },
        {
          disableLoading: true,
          disableAlert: true,
          disableNetWorkError: true,
        }
      )
    }
  }

  // ios10 env.login()页面不刷新问题
  async ios10ShadowClick() {
    window.location.reload()
  }

  // 根据各种情况处理操作
  async handlerAction() {
    if (
      +new Date() <
      +new Date(this.child_activity_Info.end_time.replace(/-/g, '/'))
    ) {
      //如果活动时间未到，判断是否还有奖品
      //先判断最后一阶梯的奖励是否领完
      if (
        !this.configInfo.stage_info ||
        !this.configInfo.stage_info[this.configInfo.stage_num] ||
        !this.configInfo.stage_info[this.configInfo.stage_num].stage_limit
      ) {
        //领完了 点击无效
        return
      }
      let myTeam: any = this.$refs.myTeam
      //判断当前我是否在该队伍中
      if (this.myTeamId) {
        //我在的话，判断当前阶段奖励是否还有
        let nowStage = myTeam.stageTable[0][0] && myTeam.stageTable[0][0].stage
        if (nowStage) {
          //当前阶梯的奖励还有
          if (
            this.configInfo.stage_info[nowStage] &&
            this.configInfo.stage_info[nowStage].stage_limit
          ) {
            if (this.userType === 1) {
              //组队成功了,实体的情况填写地址
              if (this.team_status === 'TEAM_HAS_SUCCESS' && this.isPhysical) {
                this.goAddress()
              } else if (this.team_status === 'TEAM_IS_WAITING') {
                //组队中 继续邀请
                this.inviteMore()
              } else if (this.team_status === 'TEAM_HAS_FAIL') {
                this.pushlishMyTeam(2)
              }
            } else if (this.userType === 2) {
              if (this.team_status === 'TEAM_HAS_SUCCESS') {
                //如果是实体奖励且已确认地址 让我发起组队 或者不是实体奖
                if (!this.isPhysical || (this.isConfirmed && this.isPhysical)) {
                  this.pushlishMyTeam(1)
                } else if (!this.isConfirmed && this.isPhysical) {
                  //如果是实体奖且没确认地址 去确认
                  this.goAddress()
                }
              } else if (
                this.team_status === 'TEAM_IS_WAITING' ||
                this.team_status === 'TEAM_HAS_FAIL' ||
                this.team_status === 'TEAM_HAS_FULL'
              ) {
                //组队中 允许发起组队
                this.pushlishMyTeam(1)
              }
            }
          }
        } else {
          console.error('未找到队长当前的阶梯')
        }
      } else {
        //没有组队
        if (this.invitedId) {
          if (this.join_reward_auth) {
            return this.$Toast('您已有该课程权限请关注其他组队活动')
          }
          if (this.user_type === 'no_register' && !this.isNewer) {
            this.showStatus({
              status: 5,
              child_id: this.id,
              auth: this.join_reward_auth,
            })
            return
          }
          //join_auth 有没有加入的权限
          if (
            this.mem_id &&
            this.user_type === 'no_gift_authority_app' &&
            !this.join_auth
          ) {
            this.showStatus({
              status: 12,
              shareAppName: this.chooseApp,
              child_id: this.id,
              auth: this.join_reward_auth,
            })
            return
          }
          if (this.team_status === 'TEAM_IS_WAITING') {
            //当前已发起组队
            let nowStage =
              myTeam.stageTable[0][0] && myTeam.stageTable[0][0].stage
            if (
              this.configInfo.stage_info[nowStage] &&
              this.configInfo.stage_info[nowStage].stage_limit
            ) {
              //此队伍当前阶段奖励还有 可以加入
              this.joinFreeTeam()
            }
          } else {
            //其余情况 我可以发起
            if (
              this.configInfo.stage_info[1] &&
              this.configInfo.stage_info[1].stage_limit
            ) {
              this.pushlishMyTeam(1)
            }
          }
        } else {
          //没有邀请者 发起组队
          if (
            this.configInfo.stage_info[1] &&
            this.configInfo.stage_info[1].stage_limit
          ) {
            this.pushlishMyTeam(1)
          }
        }
      }
    }
  }

  // 跳转我的组队记录页面
  goToHistory() {
    this.$router.push({
      path: `/teamFree/teamRecord`,
    })
  }

  async showStatus(info) {
    await showDiv(StatusDialog, {
      activityId: this.activityId,
      receiverId: this.receiverId || this.attend_receiverId,
      qr_code_url: this.qr_code_url,
      ...info,
    })
  }

  async inviteMore() {
    let appName = env.type === 'ivydad' ? this.appName : 'h5'
    try {
      // 埋点-再邀X人免费领按钮的点击
      await addStatistics({
        activity_id: this.activityId,
        event_type: 'Click_GetFree_xszd',
        p1: this.id,
        p2: appName,
      })
    } catch {}
    const { data: shareInfo } = await requireGet(
      `/api/activity/appActivity/teamActivity/getUserPoster?activityId=${
        this.activityId
      }&team_id=${this.myTeamId}&team_activity_id=${this.id}&appName=${appName}`
    )
    if (!shareInfo.status_code) {
      this.share_img_url = shareInfo
      this.showShare = true
    } else {
      this.$Toast(shareInfo.message)
    }
  }

  async showRule(type) {
    switch (type) {
      case 'activityRule':
        try {
          // 埋点-活动规则按钮的点击
          await addStatistics({
            activity_id: this.activityId,
            event_type: 'Click_ActivityRules_xszd',
            p1: this.id,
            p2: env.type === 'ivydad' ? this.appName : 'h5',
            p3: this.userType,
          })
        } catch {}
        break
      case 'detailRule':
        try {
          // 埋点-详细规则按钮的点击
          await addStatistics({
            activity_id: this.activityId,
            event_type: 'Click_DetailedRules_xszd',
            p1: this.id,
            p2: env.type === 'ivydad' ? this.appName : 'h5',
            p3: this.userType,
          })
        } catch {}
        break
    }
    await showDiv(RulePanel, {
      rules: this.rules,
    })
  }

  async goToShipAddress(type?) {
    if (type && type === 'click') {
      try {
        // 埋点-收货地址按钮的点击
        await addStatistics({
          activity_id: this.activityId,
          event_type: 'Click_ShippingAddress_xszd',
          p1: this.id,
          p2: env.type === 'ivydad' ? this.appName : 'h5',
          p4: this.userType,
        })
      } catch {}
    }
    if (!(await env.getIsLogin())) {
      this.ios10Shadow = true
      return await env.login()
    }
    if (!this.myTeamId) {
      return this.$Toast('请先加入组队～')
    }
    if (this.receiverId || this.attend_receiverId) {
      let { data: addressInfo } = await requirePost(
        '/api/mobile/course/yaya/getUserReceiver',
        {
          id: this.receiverId || this.attend_receiverId,
        }
      )
      if (!addressInfo.length) return (this.receiverId = '')
      this.address_info = addressInfo[0]
    } else {
      let { data } = await requirePost(
        `/api/mobile/course/yaya/getUserReceiver`,
        {
          is_default: 1,
        }
      )
      if (data && data.length) {
        this.address_info = data[0]
        this.defaultReceiverId = this.address_info.id
      }
    }
    this.showShipAddress = true
  }

  async goAddress() {
    let resUrl = new ChangeURLArg(window.location.href)
    let href = resUrl
      .removeQuery('receiver_id')
      .removeQuery('ignoreStastics')
      .removeQuery('_hideShareButton')
      .getResult()
    const host =
      config.env === 'production'
        ? `https://m.ivydad.com/`
        : `http://m.ivydad.com.cn/`
    let token = await env.getToken()
    let cur_url = `${href}${href.includes('?') ? '&' : '?'}ignoreStastics=1`
    let receiverId = this.receiverId || this.attend_receiverId || ''
    window.location.href = `${host}center/address/addressList?mode=select&receiverId=${receiverId}&_hideShareButton=1&token=${token}&redirect=${encodeURIComponent(
      cur_url
    )}`
  }

  async joinFreeTeam() {
    try {
      // 埋点-加入组队免费领按钮的点击
      await addStatistics({
        activity_id: this.activityId,
        event_type: 'Click_JoinTeam_xszd',
        p1: this.id,
        p2: env.type === 'ivydad' ? this.appName : 'h5',
      })
    } catch {}
    await env.init()
    if (!(await env.getIsLogin())) {
      this.ios10Shadow = true
      return await env.login()
    }
    const { data: res } = await requirePost(
      '/api/activity/appActivity/teamActivity/joinTeam',
      {
        team_id: this.invitedId,
        app_name: env.type === 'ivydad' ? this.appName : 'h5',
        team_activity_id: this.id,
      },
      {
        disableLoading: false,
        disableAlert: false,
        disableNetWorkError: true,
      }
    )
    if (res.status_code && res.status_code === 'JOINING_OTHER_TEAM') {
      this.showStatus({ status: 13 })
    } else if (res.message === 'ok') {
      this.initTeamDetail()
    } else {
      this.$Toast(res.message)
    }
  }

  async pushlishMyTeam(type) {
    //如果已有奖励
    if (this.publish_reward_auth) {
      return this.$Toast('您已有该课程权限请关注其他组队活动')
    }
    if (type === 1) {
      // 区分埋点
      try {
        // 埋点-发起组队按钮的点击
        await addStatistics({
          activity_id: this.activityId,
          event_type: 'Click_ATeam_xszd',
          p1: this.id,
          p2: env.type === 'ivydad' ? this.appName : 'h5',
        })
      } catch {}
    } else {
      try {
        // 埋点-重新发起组队按钮的点击
        await addStatistics({
          activity_id: this.activityId,
          event_type: 'Click_NewTeam_xszd',
          p1: this.id,
          p2: env.type === 'ivydad' ? this.appName : 'h5',
        })
      } catch {}
    }
    await env.init()
    if (!(await env.getIsLogin())) {
      this.ios10Shadow = true
      return await env.login()
    }
    const { data: res } = await requirePost(
      '/api/activity/appActivity/teamActivity/publishTeam',
      {
        team_activity_id: this.id,
        app_name: env.type === 'ivydad' ? this.appName : 'h5',
      },
      {
        disableLoading: false,
        disableAlert: false,
        disableNetWorkError: true,
      }
    )
    if (res.status_code && res.status_code === 'JOINING_OTHER_TEAM') {
      this.showStatus({ status: 13 })
    } else if (res.team_id) {
      this.invitedId = res.team_id
      await this.initTeamDetail()
      this.isShowReward = true
      //发起组队成功后，直接弹海报
      this.inviteMore()
    } else {
      this.$Toast(res.message)
    }
  }
  //展示发起组队奖励
  showPubishReward() {
    if (this.configInfo.publish_reward_info) {
      this.showStatus({
        status: 14,
        publish_reward_name: this.configInfo.publish_reward_info.name,
      })
    }
  }
  async toService(type?) {
    if (type && type === 'click') {
      try {
        // 埋点-关注公众号按钮的点击
        await addStatistics({
          activity_id: this.activityId,
          event_type: 'Click_FollowAccount_xszd',
          p1: this.id,
          p2: env.type === 'ivydad' ? this.appName : 'h5',
          p3: this.userType,
        })
      } catch {}
    }
    this.showStatus({
      status: 10,
      child_id: this.id,
      userType: this.userType,
      qr_code_url: this.qr_code_url,
    })
  }

  getPercent() {
    const container: any = this.$refs.indexContainer
    let percent =
      ((container.scrollTop + container.offsetHeight) /
        container.scrollHeight) *
      100
    if (this.displayPercent < +percent.toFixed(2)) {
      this.displayPercent =
        +percent.toFixed(2) >= 100 ? 100 : +percent.toFixed(2)
    }
  }

  goodsToast() {
    if (!this.goodsState) this.$Toast('奖品异常，请联系客服')
  }
  async shareSuccess() {
    // await showDiv(ShareSuccessModel, {
    //   organizer_reward_name:
    //     this.child_activity_Info.config.organizer_reward_name || '奖品',
    // })
    if (this.isShowReward) {
      this.isShowReward = false
      this.showPubishReward()
    }
  }
  goMyList() {
    this.$router.push({
      path: `/teamFree/myPrize`,
      query: {
        activityId: this.activityId,
        _hideShareButton: '1',
      },
    })
  }
}
